import { type ReactNode } from 'react'

interface EmptyComponentContainerProps {
	children: ReactNode
}

export const EmptyComponentContainer = ({
	children,
}: EmptyComponentContainerProps) => {
	return (
		<div className="flex h-full flex-col py-4 text-primary-400">
			<div className="relative h-full flex-grow">{children}</div>
		</div>
	)
}
